import { Button, Collapse, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useConfirm } from 'material-ui-confirm';

import useAuth from 'hooks/useAuth';
import useCurrentUser from 'hooks/useCurrentUser';

export default function BarraLoginDeSuporte() {
  const user = useCurrentUser();
  const auth = useAuth();
  const confirm = useConfirm();

  const isLoginDeSuporte = user?.is_suporte_interno;

  const handleConfirmSignOut = () => {
    confirm({
      title: <Typography variant="body2">Sair</Typography>,
      description: (
        <Typography variant="caption">Deseja mesmo sair?</Typography>
      ),
      cancellationText: 'Cancelar',
      confirmationText: 'Sair',
      confirmationButtonProps: { color: 'secondary', variant: 'contained' },
      dialogProps: { maxWidth: 'xs' },
    })
      .then(auth.signOut)
      .catch(() => {
        //
      });
  };

  return (
    <Collapse in={isLoginDeSuporte} collapsedSize="auto">
      <Alert
        style={{ width: '100%', borderRadius: 0 }}
        severity="info"
        action={
          <Button size="small" onClick={handleConfirmSignOut}>
            Sair
          </Button>
        }
      >
        Logado através do gestor para a empresa <b>{user?.tenant?.nome}</b>
      </Alert>
    </Collapse>
  );
}
